import * as React from 'react';
import { createSyncObservable, useObservable } from '@avensia/excite';

const [observable] = createSyncObservable<boolean>(false);

function close() {
  observable.emit(false);
}

export function useDesktopMenuState() {
  const menuState = useObservable(observable);

  const open = React.useCallback(() => {
    observable.emit(true);
  }, []);

  return { open, close, menuState };
}
